const type = 'START_CUSTOMER_BY_CARDS_FETCHING';

const startCustomersByCardsFetching = () => ({
  type,
});

export { type };
export default startCustomersByCardsFetching;
